module.exports = __webpack_public_path__ + "img/5.07633985.png";